import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { ErrorHandlerService } from "../../services/shared/error-handler.service";
import { ReservationService } from "../../services/reservation-service/reservation.service";
import { UserServiceService } from "../../services/user-service/user-service.service";

@Component({
  selector: "app-developer-wallet-report",
  templateUrl: "./developer-wallet-report.component.html",
  styleUrls: ["./developer-wallet-report.component.css"],
})
export class DeveloperWalletReportComponent implements OnInit {
  filter_expand = true;
  filterForm: FormGroup;
  projects: any = [];
  report: any;
  rows: any = [];
  page = 1;
  page_length = 15;
  lg: any = "lg";

  columns = [
    { label: "RF Serial", key: "rf_serial" },
    { label: "Unit Serial", key: "unit_serial" },
    { label: "Direct Amount", key: "direct_amount", currency: true },
    { label: "Direct Percentage", key: "direct_percentage", percentage: true },
    { label: "Indirect Amount", key: "indirect_amount", currency: true },
    { label: "Indirect Percentage", key: "indirect_percentage", percentage: true },
    { label: "Partner Amount", key: "partner_amount", currency: true },
    { label: "Partner Percentage", key: "partner_percentage", percentage: true },
    { label: "Total Amount", key: "total_amount", currency: true },
    { label: "Total Percentage", key: "total_percentage", percentage: true },
  ];

  constructor(
    private userService: UserServiceService,
    private errorHandlerService: ErrorHandlerService,
    private formBuilder: FormBuilder,
    private slimLoadingService: SlimLoadingBarService,
    private reservationService: ReservationService
  ) {}

  ngOnInit() {
    this.createForm();
    this.getProjects();
    this.getReport();
  }

  createForm() {
    this.filterForm = this.formBuilder.group({
      rf_serial: [""],
      unit_serial: [""],
      project_ids: [[]],
      filter_project_id: [""],
      date_from: [""],
      date_to: [""],
    });
  }

  getProjects() {
    this.reservationService.getProjects({ is_select_form: true }).subscribe(
      (data: any) => (this.projects = data || []),
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  getReport() {
    const params = {
      ...this.filterForm.value,
      page: this.page,
      page_length: this.page_length,
    };
    this.slimLoadingService.start();
    this.userService.getDeveloperWalletCommissionBreakdown(params).subscribe(
      (res: any) => {
        this.report = res;
        this.rows = this.extractRows(res);
        this.slimLoadingService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingService.complete();
      }
    );
  }

  extractRows(res) {
    if (Array.isArray(res)) return res;
    if (res && Array.isArray(res.data)) return res.data;
    if (res && res.data && Array.isArray(res.data.data)) return res.data.data;
    if (res && res.report && Array.isArray(res.report.data)) return res.report.data;
    return [];
  }

  get paginator() {
    if (this.report && this.report.data && this.report.data.data) return this.report.data;
    if (this.report && this.report.report && this.report.report.data) return this.report.report;
    if (this.report && this.report.data) return this.report;
    return null;
  }

  changePageLength(pageLength) {
    this.page_length = pageLength;
    this.page = 1;
    this.getReport();
  }

  pageChange(page) {
    this.page = page;
    this.getReport();
  }

  resetFilter() {
    this.createForm();
    this.page = 1;
    this.page_length = 15;
    this.getReport();
  }

  exportReport() {
    this.userService.exportDeveloperWalletCommissionBreakdown(this.filterForm.value).subscribe(
      (res: any) => window.open(res.url),
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/developer-wallet/developer-wallet-report/developer-wallet-report.component.ts